import type { ReactNode } from 'react'

export interface WhyJoinProps {
  image: string
  subTitle: string
  title: string
  descr: string
  /** The accordion, passed in by the page. */
  children: ReactNode
  /**
   * `plain` — `faq.html`: the row sits directly inside `.ul-container`.
   * `wrapped` — `services.html`: the section adds `pt-0` and an extra
   * `.ul-why-join-wrapper.ul-section-spacing` around the container.
   *
   * The inner column content is byte-identical between the two, which is the part
   * worth sharing; only the outer wrapper differs.
   */
  variant?: 'plain' | 'wrapped'
}

/** The `.ul-why-join` section, shared by `faq.html` and `services.html`. */
export function WhyJoin({ image, subTitle, title, descr, children, variant = 'plain' }: WhyJoinProps) {
  const row = (
    <div className="ul-container">
      <div className="row row-cols-md-2 row-cols-1 gy-4 align-items-center">
        <div className="col">
          <div className="ul-why-join-img">
            <img src={image} alt="Image" />
          </div>
        </div>
        {/* txt */}
        <div className="col">
          <div className="ul-why-join-txt">
            <span className="ul-section-sub-title">{subTitle}</span>
            <h2 className="ul-section-title">{title}</h2>
            <p className="ul-section-descr">{descr}</p>
            {children}
          </div>
        </div>
      </div>
    </div>
  )

  if (variant === 'wrapped') {
    return (
      <section className="ul-why-join ul-section-spacing pt-0">
        <div className="ul-why-join-wrapper ul-section-spacing">{row}</div>
      </section>
    )
  }

  return <section className="ul-why-join ul-section-spacing">{row}</section>
}
